<template>
  <div class="productPage">
    <NuxtLayout name="header" />
    pageType: {{ state.allData?.pageType }}
    <ProductTemp1 v-if="state.allData?.pageType === 'software'" />
    <div v-else style="color: #fff; text-align: center; margin: 100px 0">
      The product does not exist and has been removed from shelves.
    </div>

    <ProductComponentsBAddCart v-if="state.allData?.pageType" />

    <NuxtLayout name="footer" />
  </div>
</template>

<script setup lang="ts">
import Event from "@/stores";

const route = useRoute();
logInfo("route.params", route.params);

const state = reactive({
  allData: {},
  tabData: {},
});

// LiDAR360  LiDAR360MLS  LiPowerline
const res = await useFetch(
  constants.BASE_URL + api.getGoodsDetail + `?goodsCode=${route.params.name}`,
  {
    method: "get",
  }
);
logInfo(
  `${constants.BASE_URL + api.getGoodsDetail} 商品详情返回数据`,
  res?.data
);
state.allData = res?.data?.value?.data;
provide("allData", state.allData);

const res2 = await useFetch(
  constants.BASE_URL + api.getProductInfo + `?goodsCode=${route.params.name}`,
  {
    method: "get",
  }
);
logInfo(
  `${constants.BASE_URL + api.getProductInfo} 商品详情2返回数据`,
  res2?.data
);
state.tabData = res2?.data?.value?.data;
provide("tabData", state.tabData);
</script>

<style lang="less" scoped>
.productPage {
  // border: 1px solid green;
  background-color: @bgColor;
  overflow-x: clip;
  padding-bottom: 96px;
  // .fcf( 15,#fff);
}
</style>
